import { AuthResponse, MccsRoles } from '@/@types/generated'
import { Feature } from './feature'
import { hasRole } from '@/components/Atoms/Permissions'

export const CasesFeature = {
  // Roles that are eligible for the Cases feature
  // Only internal roles (marked with *) can access: system, administrator, chief_investigator, investigator, legal, credentialing, credentialing_admin, finance, insurance_provider
  Roles: [
    MccsRoles.CHIEF_INVESTIGATOR,
    MccsRoles.INVESTIGATOR,
    MccsRoles.LEGAL,
    MccsRoles.CREDENTIALING,
    MccsRoles.CREDENTIALING_ADMIN,
    MccsRoles.FINANCE,
  ] as const as MccsRoles[],

  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(CasesFeature.Roles, user),

  // Sub-features

  // Can edit case details
  // User without this feature will see readonly case views
  Edit: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(
        [MccsRoles.CHIEF_INVESTIGATOR, MccsRoles.INVESTIGATOR, MccsRoles.LEGAL],
        user
      ),
  } satisfies Feature,
} satisfies Feature
